import React, { useEffect, useState } from "react";
import Layout2 from "@/components/Layout/Layout2";
import { onlineOrderingLinks } from "@/components/lib/SidebarLinks";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import Paginat from "@/components/lib/paginat";
import { useSelector, useDispatch } from "react-redux";
import AllOrderRequestTable from "@/components/online-ordering/websiteOrdering/AllOrderRequestTable";
import useDebounce from "@/hooks/useDebounce";
import { fetchOrderWiseStatus } from "@/redux/slice/order-ordering-slice/order-status-slice";
import useAuth from "@/hooks/useAuth";
import OnlyTableSekeleton from "@/components/skeleton/only-table-skeleton";
// import PusherHandler from "@/api/lib/pusher/PusherHandler";

const OrderRequest = () => {
  const dispatch = useDispatch();
  const { pagination, getLoading, orders } = useSelector(
    (state) => state.onlineOrdering.orderStatus,
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [orderType, setOrderType] = useState(null);
  const [perPage, setPerPage] = useState("10");
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState("pending");
  const [sortField, setSortField] = useState("unique_id");
  const [sortOrder, setSortOrder] = useState("desc");
  const debouncedSearchTerm = useDebounce(query);
  const { user } = useAuth();

  // const {
  //     connectionStatus: tableStatus,
  //     lastUpdate: lastTableUpdate,
  //     addEventHandler,
  //     isConnected: tableConnected
  // } = PusherHandler();

  useEffect(() => {
    dispatch(
      fetchOrderWiseStatus({
        restaurant_id: user.restaurant_id,
        // source: "website",
        order_type: orderType,
        status: status,
        stage: "pending",
        sort_field: sortField,
        sort_order: sortOrder,
        page: currentPage,
        per_page: Number(perPage),
        search_term: debouncedSearchTerm,
      }),
    );
  }, [
    dispatch,
    currentPage,
    perPage,
    debouncedSearchTerm,
    user.restaurant_id,
    orderType,
    status,
    sortField,
    sortOrder,
  ]);

  // useEffect(() => {

  //   addEventHandler('new-online-notification', (data) => {
  //     if(data?.shared_till_ids && data?.shared_till_ids?.includes(settings?.take_order?.device_id)) {
  //       playIncomingSound();
  //       console.log("Received new-online-notification event:", data);
  //       if(data?.category == "online_notification") {

  //         if(data?.type == "online_order_placed") {
  //           setNotifications((prev) => [data, ...prev]);
  //           setTotalUnread((prev) => prev + 1);
  //           toast.success( data?.message || "New online order received");
  //         }
  //         else if(data?.type == "online_order_accepted" || data?.type == "online_order_rejected") {
  //           toast.success( data?.message || `Order ${data?.data?.unique_id} ${data?.data?.status}`);
  //           // remove order with data?.data?.order_id if it exists in the list
  //           setNotifications((prev) =>
  //             prev.filter((item) => item?.data?.online_order_id !== data?.data?.online_order_id)
  //           );
  //           setNotifications((prev) => [data, ...prev]);


  //         }
  //         else if(data?.type == "reservation_created") {
  //           setNotifications((prev) => [data, ...prev]);
  //           setTotalUnread((prev) => prev + 1);
  //           toast.success( data?.message || "New online reservation received");
  //         }
  //         else if(data?.type == "reservation_accepted" || data?.type == "reservation_rejected") {
  //           toast.success( data?.message || `Order ${data?.data?.unique_id} ${data?.data?.status}`);
  //           // remove reservation with data?.data?.reservation_id if it exists in the list
  //           setNotifications((prev) =>
  //             prev.filter((item) => item?.data?.reservation_id !== data?.data?.reservation_id)
  //           );
  //           setNotifications((prev) => [data, ...prev]);
  //         }
  //       }
  //     }
  //   })

  // }, [addEventHandler, tableStatus, tableConnected]);


  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={onlineOrderingLinks} />}
      pageName={{ title: "Order Request" }}
      paths={[
        // { name: "Home", path: "/home" },
        // { name: "Online Ordering", path: "/online-ordering" },
        {
          name: "Website Ordering",
          path: "/onlineordering/website-ordering/order-request",
        },
        { name: "Order Request" },
      ]}
    >
      <div className="container flex flex-col gap-4 mt-5">
        <Card className="bg-cblack3 border-0">
          <CardContent className="flex justify-between flex-col gap-5 items-center mt-4">
            <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
              <div className="flex justify-between items-center gap-3">
                <div className="grid w-full min-w-[250px] items-center gap-1.5">
                  <Label className="text-base text-white" htmlFor="">
                    Order ID/Name/Phone
                  </Label>
                  <Input
                    className="text-gray-300"
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Search by Order ID/Name/Phone"
                  />
                </div>
                <div className="grid w-full max-w-sm items-center gap-1.5">
                  <Label className="text-base text-white" htmlFor="">
                    Order Type
                  </Label>
                  <Select value={orderType} onValueChange={setOrderType}>
                    <SelectTrigger className="w-[200px]">
                      <SelectValue placeholder="Filter by type" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        <SelectLabel>Order Type</SelectLabel>
                        <SelectItem value={null}>All</SelectItem>
                        <SelectItem value="delivery">Delivery</SelectItem>
                        <SelectItem value="pick_up">Pick up </SelectItem>
                        <SelectItem value="reservation">Reservation</SelectItem>
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <h3 className="text-white">Show</h3>
                <Select value={perPage} onValueChange={setPerPage}>
                  <SelectTrigger className="w-[60px]">
                    <SelectValue placeholder="10" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem value="10">10</SelectItem>
                      <SelectItem value="20">20</SelectItem>
                      <SelectItem value="50">50</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </div>
            </div>
            <div className="w-full">
              {getLoading ? (
                <OnlyTableSekeleton header={false} row={3} />
              ) : (
                <AllOrderRequestTable
                  setSortField={setSortField}
                  setSortOrder={setSortOrder}
                  sortOrder={sortOrder}
                  tableData={orders}
                />
              )}

              <Paginat
                className="mt-2"
                pagination={pagination}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout2>
  );
};

export default OrderRequest;
